import { isEmpty, omitBy, has, omit } from 'lodash';

import {
  filterTypes,
  defaultFilterList,
} from 'modules/StudentScopeFilter/filters';

export const formatActiveFilters = (activeFilters = {}) =>
  Object.keys(activeFilters)
    .filter(k => activeFilters[k])
    .join();

export const formatFilters = (
  selected,
  filterList = [],
  customFilterTypes = {},
) => {
  const filterListToReturn =
    filterList?.length > 0 ? filterList : defaultFilterList;

  const usedFilterTypes = isEmpty(customFilterTypes)
    ? filterTypes
    : customFilterTypes;

  const formattedFilters = filterListToReturn.reduce((agg, entry) => {
    if (isEmpty(usedFilterTypes[entry])) {
      console.warn(`Filter ${entry} not supported!`);
      return agg;
    }
    return {
      ...agg,
      ...usedFilterTypes[entry].getQueryParamValue({
        data: usedFilterTypes[entry].getDataFromState(selected),
        queryParamKey: usedFilterTypes[entry]?.queryParamKey,
      }),
    };
  }, {});
  const omitEmptyFilterResult = omitBy(formattedFilters, isEmpty);
  return omitEmptyFilterResult;
};

export const filterOutEmptyFilters = filters =>
  Object.keys(filters).reduce((res, key) => {
    const hasOptions = Boolean(
      filters[key].options?.length ||
        filters[key].searchTerm ||
        !isEmpty(filters[key]?.nestedFilter),
    );
    const isSearchable = Boolean(filters[key].searchable);
    if (hasOptions || isSearchable) {
      res[key] = filters[key];
    }
    return res;
  }, {});

export const toggleFilterSelection = ({
  filterData,
  selectedState,
  storeLocalStorage = true,
}) => {
  const { group, id, label, source, ...rest } = filterData;
  if (has(selectedState, [group, id]) && !rest?.addOnly) {
    // when selected, toggle off selected
    if (Object.keys(selectedState[group]).length === 1) {
      // when filter group has only one selected, remove group
      if (storeLocalStorage)
        localStorage.setItem(
          'selectedStudentScopeFilter',
          JSON.stringify(omit(selectedState, group)),
        );
      return omit(selectedState, group);
    }
    // when filter group has multiple selected
    // remove the incoming selected
    if (storeLocalStorage)
      localStorage.setItem(
        'selectedStudentScopeFilter',
        JSON.stringify({
          ...selectedState,
          [group]: omit(selectedState[group], id),
        }),
      );
    return {
      ...selectedState,
      [group]: omit(selectedState[group], id),
    };
  }

  if (rest?.singleFilter) {
    // if it's single filter, update the selection
    if (storeLocalStorage)
      localStorage.setItem(
        'selectedStudentScopeFilter',
        JSON.stringify({
          ...selectedState,
          [group]: {
            [id]: { group, id, label, source, ...rest },
          },
        }),
      );

    return {
      ...selectedState,
      [group]: {
        [id]: { group, id, label, source, ...rest },
      },
    };
  }

  // if it's not filter, add the selection
  if (storeLocalStorage)
    localStorage.setItem(
      'selectedStudentScopeFilter',
      JSON.stringify({
        ...selectedState,
        [group]: {
          ...selectedState[group],
          [id]: { group, id, label, source, ...rest },
        },
      }),
    );

  return {
    ...selectedState,
    [group]: {
      ...selectedState[group],
      [id]: { group, id, label, source, ...rest },
    },
  };
};

export const removeFilterGroup = ({ selectedState, filterGroup }) =>
  omit(selectedState, filterGroup);
